import React from 'react'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { ProgramType } from '@swagger'
import DateField, { DateFieldVariant } from '../../../Elements/DateField'

interface LcdLicensingPaymentHistoryFiltersProps {
  dateFilter: string
  programFilter: string
  onDateChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onProgramChange: (event: SelectChangeEvent<string>) => void
}

const LcdLicensingPaymentHistoryFilters: React.FC<
  LcdLicensingPaymentHistoryFiltersProps
> = ({ dateFilter, programFilter, onDateChange, onProgramChange }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const handleOnKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    event.preventDefault()
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="right"
      marginBottom={theme.spacing(2)}
    >
      <Box margin={theme.spacing(0, 3)} sx={{ minWidth: 200 }}>
        <FormControl variant="outlined" fullWidth>
          <Select
            id="programFilter"
            displayEmpty
            value={programFilter}
            onChange={onProgramChange}
            renderValue={(selected) => {
              if (!selected) {
                return t(
                  'LcdLicensingPaymentHistory.AllPrograms',
                  'All Programs'
                )
              }
              return selected
            }}
            sx={{
              borderRadius: 1.5,
              '& .MuiSelect-select': {
                py: 0.75,
                px: 2,
              },
              '& .MuiOutlinedInput-notchedOutline': { borderColor: 'divider' },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'text.secondary',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'text.primary',
              },
            }}
          >
            <MenuItem value="">
              {t('LcdLicensingPaymentHistory.AllPrograms', 'All Programs')}
            </MenuItem>
            {Object.values(ProgramType)
              .filter((program) => program !== ProgramType.Scribblers)
              .map((program) => (
                <MenuItem key={program} value={program}>
                  {program}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box>
      <Box>
        <DateField
          dateVariant={DateFieldVariant.LicensingDate}
          variant="filled"
          type="date"
          fullWidth
          onChangeForParent={onDateChange}
          value={dateFilter}
          onKeyDown={handleOnKeyDown}
          hideLabel
          clearable
          sx={{
            minWidth: 200,
            '& input': {
              height: '100%',
              padding: theme.spacing(1.3),
            },
          }}
          InputProps={{
            disableUnderline: true,
            sx: { height: theme.spacing(4.5) },
          }}
        />
      </Box>
    </Box>
  )
}

export default LcdLicensingPaymentHistoryFilters
